import React from "react";
import { HStack } from "web/react/emo/h-stack";
import { BaseText } from "web/react/emo/shared/components/base-text/base-text";
import { VStack } from "web/react/emo/v-stack";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";

const SizeToStyles = {
    sm: "callout",
    md: "subhead",
    lg: "title-2",
} as const;
export interface CommonProps {
    size?: keyof typeof SizeToStyles;
    fullPrice?: string | number;
    minPrice?: string | number;
    inStock: boolean;
    dataTestId?: string;
}

type ConditionalProps =
    | {
          minPrice: string | number;
          maxPrice: string | number;
          inStock: true;
          salePrice?: never;
          fullPrice?: never;
      }
    | {
          fullPrice: string | number;
          salePrice?: string | number;
          maxPrice?: never;
          minPrice?: never;
      };

export type PriceProps = CommonProps & ConditionalProps;

export function Price({
    fullPrice,
    minPrice,
    maxPrice,
    salePrice,
    inStock,
    size = "sm",
    dataTestId,
}: PriceProps): JSX.Element {
    let textStyle = SizeToStyles[size];

    const hideOriginalPrice = !inStock && salePrice;
    const { isDesktopViewport } = useDomViewport();

    function priceContent(): JSX.Element {
        return (
            <>
                {!hideOriginalPrice && (
                    <BaseText
                        textStyle={textStyle}
                        strikeThrough={salePrice || !inStock ? true : false}
                    >
                        {fullPrice || minPrice}
                    </BaseText>
                )}
                {salePrice && (
                    <BaseText
                        textStyle={textStyle}
                        strikeThrough={!inStock ? true : false}
                        color={"highlightBrand"}
                    >
                        {salePrice}
                    </BaseText>
                )}
                {minPrice && maxPrice && (
                    <BaseText textStyle={textStyle}>{` - ${maxPrice}`}</BaseText>
                )}
            </>
        );
    }

    return isDesktopViewport ? (
        <HStack align="start" spacing="xxxs" dataTestId={dataTestId}>
            {priceContent()}
        </HStack>
    ) : (
        <VStack align="start" spacing="xxxs" dataTestId={dataTestId}>
            {priceContent()}
        </VStack>
    );
}
